import { styled } from '@mui/material/styles';
import { Box, TableContainer } from '@mui/material';

// Box with shadow - reusable component for cards and containers
export const ShadowBox = styled(Box)(({ theme }) => ({
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(3),
}));

// Box with light shadow - for subtle elevation
export const LightShadowBox = styled(Box)(({ theme }) => ({
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.08)',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
}));

// Box with strong shadow - for modals and important elements
export const StrongShadowBox = styled(Box)(({ theme }) => ({
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(3),
}));

// Table container with overflow handling
export const ScrollableTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 600,
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
}));

// Responsive table container - adjusts height based on screen size
export const ResponsiveTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: '70vh',
  overflow: 'auto',
  [theme.breakpoints.down('sm')]: {
    maxHeight: '60vh',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[400],
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: theme.palette.grey[600],
    },
  },
}));

// Fixed header table container
export const FixedHeaderTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 500,
  overflow: 'auto',
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f5f5f5',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#bdbdbd',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#9e9e9e',
    },
  },
}));

